'use client'

import { useAuth } from '@/context/auth-context'
import { usePathname, useRouter } from 'next/navigation'
import { useEffect } from 'react'

const authPaths = ['/login', '/two-factor', '/reset-password', '/forgot-password']

/** Redirects an already-authenticated user away from the public auth pages. */
export function AuthPageRedirector({ children }) {
  const { user, loading } = useAuth()
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    if (!loading && user && authPaths.includes(pathname)) {
      router.replace('/dashboard')
    }
  }, [user, loading, pathname, router])

  return children
}
